var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#exchange_svg__clip0_725_8329)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5a3 3 0 116 0 3 3 0 01-6 0zm3-5a5 5 0 100 10A5 5 0 005 0zm11 19a3 3 0 116 0 3 3 0 01-6 0zm3-5a5 5 0 100 10 5 5 0 000-10zm-7-9.003a.996.996 0 01.286-.698l.008-.007 2.999-3a1 1 0 111.414 1.415L15.414 4H21a1 1 0 011 1v6a1 1 0 11-2 0V6h-4.586l1.293 1.293a1 1 0 01-1.414 1.414l-3-3-.007-.006A.997.997 0 0112 5.003v-.006zM4 13a1 1 0 10-2 0v6a1 1 0 001 1h5.586l-1.293 1.293a1 1 0 101.414 1.414l3-3a.997.997 0 00.293-.704v-.006a.996.996 0 00-.293-.704l-3-3a1 1 0 00-1.414 1.414L8.586 18H4v-5z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "exchange_svg__clip0_725_8329"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgExchange;